"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSavedPlacement = exports.convertSearchPayloadForDBFormat = exports.convertArrayOfBuildingsFromDB = exports.convertArrayOfBuildingCoordinatesForDB = exports.convertSearchPayloadFromDBFormat = void 0;
const core_1 = require("@natomas-org/core");
const convertSearchPayloadFromDBFormat = (data) => {
    if (!data) {
        return null;
    }
    try {
        const { buildingsGeometry, parcelGeometry, address, streetCoordinates } = data;
        const parcelDataForClient = Object.assign({}, parcelGeometry);
        parcelDataForClient.coordinates = parcelDataForClient.coordinates.map((object) => {
            return object.path.map((coordinate) => {
                return coordinate.coordinate;
            });
        });
        const buildingDataForClient = buildingsGeometry
            ? buildingsGeometry.map((buildingDataRow) => {
                const rowCopy = Object.assign({}, buildingDataRow);
                rowCopy.coordinates = rowCopy.coordinates.map((object) => {
                    return object.path.map((coordinate) => {
                        return coordinate.coordinate;
                    });
                });
                return rowCopy;
            })
            : [];
        return {
            buildingsGeometry: buildingDataForClient,
            parcelGeometry: parcelDataForClient,
            address: address,
            center: core_1.Address.getCoordinates(address),
            streetCoordinates: streetCoordinates,
        };
    }
    catch (e) {
        return null;
    }
};
exports.convertSearchPayloadFromDBFormat = convertSearchPayloadFromDBFormat;
const convertArrayOfBuildingCoordinatesForDB = (arr) => {
    if (!arr || arr.length < 1) {
        return null;
    }
    return arr.map((buildingDataRow) => {
        var _a;
        const rowCopy = Object.assign({}, buildingDataRow);
        rowCopy.coordinates = (_a = rowCopy.coordinates) === null || _a === void 0 ? void 0 : _a.map((object) => {
            const points = object.map((point) => {
                return {
                    coordinate: point,
                };
            });
            return {
                path: points,
            };
        });
        return rowCopy;
    });
};
exports.convertArrayOfBuildingCoordinatesForDB = convertArrayOfBuildingCoordinatesForDB;
const convertArrayOfBuildingsFromDB = (arr) => {
    if (!arr) {
        return null;
    }
    return arr.map((buildingDataRow) => {
        const rowCopy = Object.assign({}, buildingDataRow);
        rowCopy.coordinates = rowCopy.coordinates.map((object) => {
            return object.path.map((coordinate) => {
                return coordinate.coordinate;
            });
        });
        return rowCopy;
    });
};
exports.convertArrayOfBuildingsFromDB = convertArrayOfBuildingsFromDB;
const convertSearchPayloadForDBFormat = (props) => {
    const { parcelData, buildingsData, projectAddress, streetCoordinates } = props;
    if (!parcelData) {
        return null;
    }
    const parcelDataForDB = Object.assign({}, parcelData);
    parcelDataForDB.coordinates = parcelDataForDB === null || parcelDataForDB === void 0 ? void 0 : parcelDataForDB.coordinates.map((object) => {
        const points = object.map((point) => {
            return {
                coordinate: point,
            };
        });
        return {
            path: points,
        };
    });
    return {
        buildingsGeometry: (0, exports.convertArrayOfBuildingCoordinatesForDB)(buildingsData),
        parcelGeometry: parcelDataForDB,
        address: projectAddress,
        center: core_1.Address.getCoordinates(projectAddress),
        streetCoordinates: streetCoordinates,
    };
};
exports.convertSearchPayloadForDBFormat = convertSearchPayloadForDBFormat;
function hasSavedPlacement(unitPlacement) {
    return unitPlacement === null || unitPlacement === void 0 ? void 0 : unitPlacement.coordinates;
}
exports.hasSavedPlacement = hasSavedPlacement;
//# sourceMappingURL=general.js.map